import { render, staticRenderFns } from "./IncidentTypeCard.vue?vue&type=template&id=0da4986f&scoped=true"
import script from "./IncidentTypeCard.vue?vue&type=script&lang=js"
export * from "./IncidentTypeCard.vue?vue&type=script&lang=js"
import style0 from "./IncidentTypeCard.vue?vue&type=style&index=0&id=0da4986f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da4986f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VIcon,VLayout,VListItem,VSelect,VTextField})
